import { RoutesMap } from 'redux-first-router';
import { Api, OrganizationProjectsListItem } from 'uf-api-rtk/store/Api';

import {
  ROUTE_ANALYSIS_EDITOR,
  ROUTE_ANALYSIS_EDITOR_WITH_KEY,
} from 'uf/analysiseditor/ActionTypes';
import { makeUpdateAnalysisEditorStateFromUrl } from 'uf/analysiseditor/routing/sync';
import { parseFullPath } from 'uf/base/dataset';
import {
  ROUTE_BUILT_FORM_EDITOR,
  ROUTE_BUILT_FORM_EDITOR_WITH_KEY,
} from 'uf/builtforms/ActionTypes';
import { makeUpdateEditorStateFromUrl } from 'uf/builtforms/routing/sync';
import { setUIProperty } from 'uf/explore/actions';
import { setExploreNewRoute } from 'uf/explore/actions/routing';
import { ROUTE_EXPLORE, ROUTE_EXPLORE_NEW } from 'uf/explore/ActionTypes';
import { ROUTE_INTERNAL } from 'uf/internal/ActionTypes';
import { makeUpdateInternalStateFromUrl } from 'uf/internal/routing/sync';
import { ROUTE_SETTINGS } from 'uf/organizations/ActionTypes';
import { ROUTE_REPORT } from 'uf/reporting/ActionTypes';
import { makeRoutingActionType } from 'uf/routing/actions';
import { ROUTE_PROFILE } from 'uf/user/ActionTypes';

// This is the main routesMap for redux-first-router
const routesMap: RoutesMap = {
  // Fallback that will hard redirect to the first project in the list
  // in the case of no projects leaving / will allow for project creation
  [makeRoutingActionType(ROUTE_EXPLORE)]: {
    path: '/',
    thunk: async dispatch => {
      // Wait for user data to populate so that we can access the last active project
      const currentUser = await dispatch(
        Api.endpoints.getCurrentUser.initiate(),
      );
      const userKey = currentUser?.data?.key;
      const userData = await dispatch(
        Api.endpoints.getUserData.initiate({
          userKey,
          key: 'pref:last_active_project_id',
        }),
      );
      // @ts-expect-error this is a valid accessor for user data
      const lastActiveProjectId = userData?.data?.value?.value;
      // Set the explore view to visible and set the last active project or get the default project if one exists
      dispatch(setUIProperty('exploreViewVisible', true));
      if (lastActiveProjectId) {
        const { namespace, key } = parseFullPath(lastActiveProjectId);
        dispatch(setExploreNewRoute(namespace, key));
      } else {
        const result = await dispatch(Api.endpoints.getProjectsV2.initiate());
        const projectsByOrg = result.data?.items || [];
        const defaultProject = projectsByOrg.find(
          (o: OrganizationProjectsListItem) => o?.projects?.length > 0,
        )?.projects?.[0];
        if (defaultProject) {
          dispatch(
            setExploreNewRoute(defaultProject.namespace, defaultProject.key),
          );
        }
      }
    },
  },
  [makeRoutingActionType(ROUTE_EXPLORE_NEW)]: {
    path: '/explore/:namespace/project/:projectKey',
  },
  [makeRoutingActionType(ROUTE_REPORT)]: {
    path: '/report/:type/:namespace/project/:projectKey',
  },
  [makeRoutingActionType(ROUTE_SETTINGS)]: {
    path: '/settings/:namespace',
  },
  [makeRoutingActionType(ROUTE_PROFILE)]: { path: '/profile' },
  [makeRoutingActionType(ROUTE_BUILT_FORM_EDITOR)]: {
    path: '/bf/:type/:namespace/builtforms/:libraryKey',
  },
  [makeRoutingActionType(ROUTE_BUILT_FORM_EDITOR_WITH_KEY)]: {
    path: '/bf/:type/:namespace/builtforms/:libraryKey/:key',
    thunk: makeUpdateEditorStateFromUrl(),
  },
  [makeRoutingActionType(ROUTE_ANALYSIS_EDITOR)]: {
    path: '/ae/analysis/:namespace/project/:projectKey',
  },
  [makeRoutingActionType(ROUTE_ANALYSIS_EDITOR_WITH_KEY)]: {
    path: '/ae/analysis/:namespace/project/:projectKey/:moduleKey',
    thunk: makeUpdateAnalysisEditorStateFromUrl(),
  },
  [makeRoutingActionType(ROUTE_INTERNAL)]: {
    path: '/internal/:pageKey?',
    thunk: makeUpdateInternalStateFromUrl(),
  },
};

export default routesMap;

if (module.hot) {
  module.hot.accept();
}
